var _path, _path2, _rect, _rect2, _g, _rect3, _g2, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _g3, _rect6, _g4, _rect7, _path8, _rect8, _g5, _rect9, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8817 1.32243C45.178 0.513188 46.822 0.513186 48.1183 1.32243L90.1183 27.5428C91.2888 28.2736 92 29.556 92 30.9359V78.7775C92 80.1574 91.2888 81.4398 90.1183 82.1705L48.1183 108.391C46.822 109.2 45.178 109.2 43.8817 108.391L1.88173 82.1706C0.711218 81.4398 0 80.1574 0 78.7775V30.9359C0 29.556 0.711217 28.2736 1.88172 27.5428L43.8817 1.32243Z",
    fill: "url(#paint0_linear_57_6382)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_6382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 92,
    height: 108
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8831 2.57015C44.4024 0.99738 47.5976 0.997379 50.1169 2.57015L88.3429 26.4344C90.6178 27.8546 92 30.3471 92 33.0289V76.6845C92 79.3663 90.6177 81.8587 88.3429 83.2789L50.1169 107.143C47.5976 108.716 44.4024 108.716 41.8831 107.143L3.65714 83.2789C1.38226 81.8587 0 79.3663 0 76.6845V33.0289C0 30.3471 1.38225 27.8546 3.65714 26.4344L41.8831 2.57015Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_6382)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.6973,
    y: 52.2153,
    width: 8.25106,
    height: 50.9245,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_57_6382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 33,
    width: 17,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.9238,
    y: 33.0049,
    width: 8.25106,
    height: 16.5021,
    transform: "rotate(90 46.9238 33.0049)",
    fill: "#CD6767"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_57_6382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4217 41.2559C30.4217 40.1724 30.6351 39.0995 31.0498 38.0984C31.4644 37.0973 32.0722 36.1877 32.8384 35.4216C33.6046 34.6554 34.5142 34.0476 35.5152 33.633C36.5163 33.2183 37.5892 33.0049 38.6728 33.0049L38.6728 41.2559L30.4217 41.2559Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_57_6382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 33,
    width: 17,
    height: 9
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5977,
    y: 33.0049,
    width: 8.25106,
    height: 16.5021,
    rx: 0.485876,
    transform: "rotate(90 61.5977 33.0049)",
    fill: "#CD6767"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_57_6382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5814 41.2559C45.3131 41.2559 45.094 41.0382 45.1098 40.7703C45.2283 38.7591 46.0797 36.8541 47.5122 35.4216C49.0596 33.8742 51.1583 33.0049 53.3466 33.0049C55.5349 33.0049 57.6336 33.8742 59.181 35.4216C60.6135 36.8541 61.4649 38.7591 61.5834 40.7703C61.5991 41.0382 61.3801 41.2559 61.1118 41.2559L53.3466 41.2559L45.5814 41.2559Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5376 63.5596C50.8059 63.5596 51.0234 63.7771 51.0234 64.0454L51.0234 71.3248C51.0234 71.5931 50.8059 71.8106 50.5376 71.8106L27.9462 71.8106L27.9462 63.5596L50.5376 63.5596Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.623 74.2607L53.372 74.2607L53.372 54.8925C53.372 54.6242 53.5895 54.4066 53.8579 54.4066L61.1372 54.4066C61.4055 54.4066 61.623 54.6242 61.623 54.8925L61.623 74.2607Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3965 41.2559L38.6475 41.2559L38.6475 60.6241C38.6475 60.8924 38.43 61.11 38.1617 61.11L30.8824 61.11C30.614 61.11 30.3965 60.8925 30.3965 60.6241L30.3965 41.2559Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0488 43.7051L64.0488 51.9561L41.5864 51.9561C41.3181 51.9561 41.1006 51.7386 41.1006 51.4703L41.1006 44.191C41.1006 43.9226 41.3181 43.7051 41.5864 43.7051L64.0488 43.7051Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3711 74.2607L53.3711 82.5118L30.4228 82.5118L30.4228 74.7466C30.4228 74.4783 30.6404 74.2607 30.9087 74.2607L53.3711 74.2607Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.2441,
    y: 33.0049,
    width: 8.25107,
    height: 14.5683,
    transform: "rotate(90 53.2441 33.0049)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_57_6382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 43,
    width: 9,
    height: 18
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2969,
    y: 60.2085,
    width: 8.25106,
    height: 16.5021,
    transform: "rotate(-180 72.2969 60.2085)",
    fill: "#CD6767"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_57_6382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0458 43.7064C66.2341 43.7064 68.3328 44.5757 69.8802 46.123C71.4276 47.6704 72.2969 49.7691 72.2969 51.9574L64.0458 51.9574L64.0458 43.7064Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_57_6382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 58,
    width: 9,
    height: 17
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3223,
    y: 74.9048,
    width: 8.25106,
    height: 16.5021,
    rx: 0.485876,
    transform: "rotate(-180 72.3223 74.9048)",
    fill: "#CD6767"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_57_6382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0712 58.8885C64.0712 58.6202 64.289 58.4012 64.5569 58.4169C66.5681 58.5355 68.4731 59.3868 69.9056 60.8193C71.453 62.3667 72.3223 64.4654 72.3223 66.6537C72.3223 68.842 71.453 70.9407 69.9056 72.4881C68.4731 73.9206 66.5681 74.772 64.5569 74.8905C64.289 74.9063 64.0712 74.6873 64.0712 74.4189L64.0712 66.6537L64.0712 58.8885Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3223,
    y: 66.6543,
    width: 8.25107,
    height: 14.6972,
    transform: "rotate(-180 72.3223 66.6543)",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4219 82.5117H38.6729V108.326C38.6729 108.594 38.4554 108.812 38.1871 108.812H30.9078C30.6394 108.812 30.4219 108.594 30.4219 108.326L30.4219 82.5117Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_57_6382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 43,
    width: 9,
    height: 18
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6973,
    y: 43.9639,
    width: 8.25106,
    height: 16.5021,
    rx: 0.485876,
    fill: "#CD6767"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_57_6382)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.9483,
    cy: 52.2149,
    r: 8.25106,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_57_6382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 74,
    width: 9,
    height: 9
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53.3711,
    y: 82.5117,
    width: 8.25106,
    height: 8.25106,
    transform: "rotate(-90 53.3711 82.5117)",
    fill: "#CD6767"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_57_6382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5959 74.2607C61.5959 75.3442 61.3825 76.4171 60.9678 77.4182C60.5531 78.4193 59.9454 79.3289 59.1792 80.095C58.413 80.8612 57.5034 81.469 56.5024 81.8836C55.5013 82.2983 54.4284 82.5117 53.3448 82.5117L53.3448 74.2607L61.5959 74.2607Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_6382",
    x1: 46,
    y1: 0,
    x2: 46,
    y2: 109.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444BAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpaLogo);
export default __webpack_public_path__ + "static/media/PPA_Logo.69e0e0aa4a49d34856b0dba4e2ebc159.svg";
export { ForwardRef as ReactComponent };